export enum WorkflowReviewFinalizeApprovalType {
  Everyone = 'everyone',
  Specific = 'specific',
}
